import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { init, Source, OperationMode } from '@feelrobotics/ftap-connector';

import './index.scss';
import 'fonts/fonts.css';
import App from './App';
import ErrorBoundary from 'components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

const isProduction = window.location.hostname === 'portal.feelme.com';

// Chargebee is loaded from a CDN script; if it fails to load (blocked, offline),
// don't let it prevent the whole app from rendering
try {
  window.Chargebee.init({
    site: isProduction ? 'feelme' : 'feelme-test',
    enableGTMTracking: true,
  });
} catch (error) {
  console.error('Chargebee init failed', error);
}

// Initialize FTAP connector
const isLocal =
  window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1');
if (isLocal) {
  init(Source.FeelMe, OperationMode.Test);
} else {
  init(Source.FeelMe, isProduction ? OperationMode.Prod : OperationMode.Stage);
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
